import Metapolicies from './Metapolicies';

export * from './types';

export default Metapolicies;
